import styled from "styled-components";

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img{
    width: 18px;
    height: 18px;
  }
`;